import type { FC } from 'react';
import React from 'react';

import { VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceStart } from '@confluence/experience-tracker/entry-points/component.ts';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { FavouriteButtonComponent } from './FavouriteButtonComponent.tsx';
import { FAVOURITE_BUTTON_METRIC } from './perf.config.ts';

type FavouriteButtonProps = {
	contentId: string;
	isDisabled?: boolean;
};

export const FavouriteButton: FC<FavouriteButtonProps> = ({ contentId, isDisabled }) => {
	const { isLoggedIn } = useSessionData();

	if (!isLoggedIn) {
		return null;
	}

	return (
		<ErrorBoundary attribution={Attribution.DISCO}>
			<PageSegmentLoadStart key={contentId} metric={FAVOURITE_BUTTON_METRIC} />
			<ExperienceStart id={contentId} name={VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE} />
			<FavouriteButtonComponent contentId={contentId} isDisabled={isDisabled} />
		</ErrorBoundary>
	);
};
